import React from 'react';
import './SkeletonTradeRow.css';

function SkeletonSummaryBar() {
  return (
    <div className="skeleton-summary-bar">
      <div className="skeleton-left">
        <div className="skeleton-bone skeleton-count" />
        <div className="skeleton-bone skeleton-label" />
        <div className="skeleton-bone skeleton-count" />
        <div className="skeleton-bone skeleton-label" />
      </div>
      <div className="skeleton-right">
        <div className="skeleton-bone skeleton-progress" />
        <div className="skeleton-bone skeleton-total" />
      </div>
    </div>
  );
}

function SkeletonTradeRow({ count = 17 }) {
  return (
    <>
      <SkeletonSummaryBar />
      <div className="card-body scroll">
        {Array.from({ length: count }, (_, i) => (
          <div className="skeleton-trade-row" key={i}>
            <div className="skeleton-left">
              <div className="skeleton-bone circle skeleton-exchange-icon" />
              <div className="skeleton-bone circle skeleton-coin-icon" />
              <div className="skeleton-bone skeleton-coin-name" />
            </div>
            <div className="skeleton-bone skeleton-volume-badge" />
          </div>
        ))}
      </div>
    </>
  );
}

export function SkeletonNewsfeed({ count = 5 }) {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <div className="skeleton-news-item" key={i}>
          <div className="skeleton-news-header">
            <div className="skeleton-bone circle skeleton-avatar" />
            <div className="skeleton-meta">
              <div className="skeleton-bone skeleton-source" />
              <div className="skeleton-bone skeleton-time" />
            </div>
          </div>
          <div className="skeleton-bone skeleton-news-text-line" style={{ width: '100%' }} />
          <div className="skeleton-bone skeleton-news-text-line" style={{ width: '90%' }} />
          <div className="skeleton-bone skeleton-news-text-line" />
        </div>
      ))}
    </>
  );
}

export function SkeletonUnusualActivity({ count = 3 }) {
  return (
    <div className="skeleton-ua-list">
      {Array.from({ length: count }, (_, i) => (
        <div className="skeleton-ua-item" key={i}>
          <div className="skeleton-ua-left">
            <div className="skeleton-bone circle skeleton-ua-icon" />
            <div className="skeleton-bone skeleton-ua-name" />
          </div>
          <div className="skeleton-ua-right">
            <div className="skeleton-bone skeleton-ua-badge" />
            <div className="skeleton-bone skeleton-ua-change" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function SkeletonStats24h() {
  return (
    <div className="stats24h-grid">
      <div className="g-col-6">
        <div className="card">
          <div className="card-header">
            <div className="skeleton-bone skeleton-stats24h-header" />
          </div>
          <div className="card-body pd pt-0 text-center">
            <div className="skeleton-bone skeleton-stats24h-number" />
          </div>
        </div>
      </div>
      <div className="g-col-6">
        <div className="card">
          <div className="card-header">
            <div className="skeleton-bone skeleton-stats24h-header" />
          </div>
          <div className="card-body pd pt-0 text-center">
            <div className="skeleton-bone skeleton-stats24h-number" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SkeletonTradeRow;
